import styled from 'styled-components';
export const LoadingCentered = styled.div.withConfig({
  displayName: "Loadingstyles__LoadingCentered"
})(["display:flex;align-items:center;justify-content:center;flex-direction:column;text-align:center;max-height:", "px;"], ({
  maxHeight
}) => maxHeight || 350);